import { APP_URL } from "../constants";
import { httpClient } from "../utils/http-client";

const makeMomoDepositTransaction = async (data) => {
    try {
        return httpClient.post(APP_URL + `/v1/tx/momo-deposit/${data.id}`, {
            pin: data.pin, phone: data.momoDepositNumber, name: data.momoDepositName, reference: data.reference
        })
    } catch (error) {
        console.log("Error Sending request", error);
        return error;
    }
}

const makeMomoCashoutTransaction = async (data) => {
    try {
        return httpClient.post(APP_URL + `/v1/tx/momo-cashout/${data.id}`, {
            pin: data.pin, phone: data.momoDepositNumber, name: data.momoDepositName
        })
    } catch (error) {
        console.log("Error Sending request", error);
        return error;
    }
}

const makeMopayTransaction = async (data) => {
    try {
        return httpClient.post(APP_URL + `/v1/tx/momo-pay/${data.id}`, {
            pin: data.pin, phone: data.mopayNumber, name: data.mopayName
        })
    } catch (error) {
        console.log("Error Sending request", error);
        return error;
    }
}

const makeAgentCashoutTransaction = async (data) => {
    try {
        return httpClient.post(APP_URL + `/v1/tx/agent-cashout/${data.id}`, {
            pin: data.pin, agent_code: data.agentCode
        })
    } catch (error) {
        console.log("Error Sending request", error);
        return error;
    }
}

const postAd = async (data) => {
    try {
        return httpClient.post(APP_URL + `/v1/tx/ads/${data.id}`, {
            pin: data.pin, title: data.title, link: data.link
        });
    } catch (error) {
        console.log("Error Sending request", error);
        return error;
    }
}

const makeAgentDepositTransaction = async (data) => {
    try {
        return httpClient.post(APP_URL + `/v1/tx/agent-deposit/${data.id}`, {
            pin: data.pin, client_code: data.clientCode
        })
    } catch (error) {
        console.log("Error Sending request", error);
        return error;
    }
}

const makeMerchantPayment = async (data) => {
    try {
        return httpClient.post(APP_URL + `/v1/wallet/pay/approve/${data.ref}`, {
            pin: Number(data.pin), client: data.clientCode
        })
    } catch (error) {
        console.log("Error Sending request", error);
        return error;
    }
}

const sendMoneyTransaction = async (data) => {
    try {
        return httpClient.post(APP_URL + `/v1/tx/send-money/${data.id}`, {
            pin: Number(data.pin),
            amount: data.amount, 
            phone: data.momoDepositNumber, 
            name: data.momoDepositName, 
            reason: data.reason, 
            from: data.from, 
            to: data.to,
            senderPhone: data.senderPhone
        })
    } catch (error) {
        console.log("Error Sending request", error);
        return error;
    }
}

const getConversionRate = async (amount, fromCur, toCur) => {
    try {
        return httpClient.get(APP_URL + `/v1/fx/convert?amount=${amount}&from=${fromCur}&to=${toCur}`, {
        })
    } catch (error) {
        console.log("Error Sending request", error);
        return error;
    }
}

const getTransactionInfo = async (data) => {
    try {
        return httpClient.get(APP_URL + `/v1/tx/${data.id}?start=${data.start+` 00:00:00`}&end=${data.end+` 23:59:59`}`, {
            'auth-token': data.pin
        })
    } catch (error) {
        console.log("Error Sending request", error);
        return error;
    }
}

const getBalanceInfo = async (data) => {
    try {
        return httpClient.get(APP_URL + `/v1/tx/balance/${data.id}`, {
            'auth-token': data.pin
        })
    } catch (error) {
        console.log("Error Sending request", error);
        return error;
    }
}

export {
    getTransactionInfo,
    getBalanceInfo,
    makeAgentDepositTransaction,
    makeAgentCashoutTransaction,
    makeMomoCashoutTransaction,
    makeMomoDepositTransaction,
    sendMoneyTransaction,
    postAd,
    makeMerchantPayment,
    getConversionRate,
    makeMopayTransaction
}